import { type RefObject, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import { CallPowerDialerBaseContent as CallPowerDialerBaseContentV2 } from 'widgets/CallPopUp/ui/CallPowerDialerV2/CallPowerDialerBaseContent/CallPowerDialerBaseContent'
import { CallPowerDialerSection as CallPowerDialerSectionV2 } from 'widgets/CallPopUp/ui/CallPowerDialerV2/CallPowerDialerSection/CallPowerDialerSection'
import { CallQueueSection } from 'widgets/CallPopUp/ui/CallQueue/CallQueueSection/CallQueueSection'
import { CallPopUpContent } from 'widgets/CallPopUp/ui/CallPopUpBase/CallPopUpContent/CallPopUpContent'
import { CallInsightCardsContent } from 'widgets/CallPopUp/ui/CallInsightCards/CallInsightCardsContent'
import { CallInsightCardsCallType } from 'widgets/CallPopUp/ui/CallInsightCards/CallInsightCardsCallType/CallInsightCardsCallType'
import styles from './styles.module.scss'

type ICallPopUpViewDefaultProps = {
  refWrap: RefObject<HTMLDivElement>
}

export const CallPopUpViewDefault: FC<ICallPopUpViewDefaultProps> = observer(({ refWrap }) => {
  const store = useCallPopUpDefaultContext()
  const entities = useEntitiesContext()
  const {
    callPopUpQueueStore,
    callPopUpPowerDialerStoreV2,
    isStatusClose,
    hasCallBeenActive,
    callPopUpInsightCardsStore,
    showPopUp,
    contactFrom,
  } = store

  const { showCallTypesModal, callPopUpCallInsightCardsCallTypeStore } = callPopUpInsightCardsStore

  const showCallInsight = !entities.usersStore.user?.isViewOnlyRole

  const isShowPopupForLastOrCurrentCall =
    contactFrom !== null &&
    entities.callStore.contactFrom !== null &&
    contactFrom.id === entities.callStore.contactFrom.id

  const showCallInsightCallTypes =
    showCallInsight &&
    showCallTypesModal &&
    isStatusClose &&
    callPopUpCallInsightCardsCallTypeStore &&
    !callPopUpPowerDialerStoreV2.isPowerDialerRunning

  const showCallInsightBlockSection =
    showCallInsight && isStatusClose && hasCallBeenActive && callPopUpCallInsightCardsCallTypeStore

  const hasCallInsightBlockContent =
    showCallInsightBlockSection &&
    ((callPopUpCallInsightCardsCallTypeStore.showModal &&
      (callPopUpCallInsightCardsCallTypeStore.hasCallTypes ||
        callPopUpCallInsightCardsCallTypeStore.loading)) ||
      store.shouldShowIncomingBlockInsightCard)

  const showCallInsightInfo =
    (showCallInsight && showPopUp) ||
    (showCallInsight && callPopUpPowerDialerStoreV2.isPowerDialerRunning) ||
    (!showPopUp && showCallInsightCallTypes)

  const renderContent = () => {
    if (isStatusClose) {
      return <CallPowerDialerBaseContentV2 refWrap={refWrap} />
    }

    return <CallPopUpContent refWrap={refWrap} />
  }

  return (
    <>
      {renderContent()}
      {isShowPopupForLastOrCurrentCall && hasCallInsightBlockContent && (
        <div className={classnames(styles.section, styles.section__indent)}>
          <CallInsightCardsCallType store={callPopUpCallInsightCardsCallTypeStore} />
        </div>
      )}
      {isShowPopupForLastOrCurrentCall && showCallInsightInfo && (
        <div className={classnames(styles.section, styles.section__indent)}>
          <CallInsightCardsContent />
        </div>
      )}

      {callPopUpPowerDialerStoreV2.isPowerDialerRunning && (
        <div className={classnames(styles.section, styles.section__indent)}>
          <CallPowerDialerSectionV2 />
        </div>
      )}

      {callPopUpQueueStore.hasItems && (
        <div className={classnames(styles.section, styles.section__indent)}>
          <CallQueueSection type={'default'} />
        </div>
      )}
    </>
  )
})
